/* =====================================================================
   SH4DE — refonte « Davril » (11/10/2026)
   Header, menu, bandeau, ajout rapide depuis les grilles, filtre
   « épuisé », estimation de livraison, apparitions au scroll.
   Le panier, le combo, la fiche produit et la pop-up restent gérés par
   sh4de-cart.js, sh4de-v2.js, sh4de-promo.js et sh4de-kairo-pages.js.
   ===================================================================== */
(function () {
  'use strict';

  var doc = document, html = doc.documentElement;
  var $ = function (s, r) { return (r || doc).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || doc).querySelectorAll(s)); };
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var T = function (k, d) { return window.SH4DE_T ? window.SH4DE_T(k, d) : d; };
  var LS = {
    get: function (k) { try { return localStorage.getItem(k); } catch (e) { return null; } },
    set: function (k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
  };

  var head = $('[data-sd-head]');
  if (head) {
    var over = head.classList.contains('sd-head--over');
    var tick = false;
    var paint = function () {
      head.classList.toggle('is-solid', !over || window.scrollY > 24 || html.classList.contains('sd-lock'));
      tick = false;
    };
    window.addEventListener('scroll', function () { if (!tick) { tick = true; requestAnimationFrame(paint); } }, { passive: true });
    paint();
  }

  var ann = $('[data-sd-ann]');
  if (ann) {
    var msgs = $$('.sd-ann__i', ann), cur = 0;
    if (msgs[0]) msgs[0].classList.add('is-on');
    if (msgs.length > 1) {
      setInterval(function () {
        if (doc.hidden) return;
        msgs[cur].classList.remove('is-on');
        cur = (cur + 1) % msgs.length;
        msgs[cur].classList.add('is-on');
      }, reduce ? 6000 : 3800);
    }
  }

  var menu = $('[data-sd-menu]'), opener = $('[data-sd-menu-open]'), lastFocus = null;
  function setMenu(open) {
    if (!menu) return;
    menu.classList.toggle('is-open', open);
    menu.setAttribute('aria-hidden', open ? 'false' : 'true');
    if (opener) opener.setAttribute('aria-expanded', open ? 'true' : 'false');
    html.classList.toggle('sd-lock', open);
    if (open) {
      lastFocus = doc.activeElement;
      var first = $('.sd-menu__top [data-sd-menu-close]', menu);
      if (first) setTimeout(function () { first.focus({ preventScroll: true }); }, 60);
    } else if (lastFocus && lastFocus.focus) {
      lastFocus.focus({ preventScroll: true });
    }
  }
  if (menu && opener) {
    opener.addEventListener('click', function () { setMenu(!menu.classList.contains('is-open')); });
    $$('[data-sd-menu-close]', menu).forEach(function (b) { b.addEventListener('click', function () { setMenu(false); }); });
    $$('.sd-menu__big a, .sd-menu__small a, .sd-menu__top a', menu).forEach(function (a) { a.addEventListener('click', function () { setMenu(false); }); });
  }
  doc.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (menu && menu.classList.contains('is-open')) setMenu(false);
    var d = $('#CartDrawer');
    if (d && d.classList.contains('active') && typeof window.closeCartDrawer === 'function') window.closeCartDrawer();
    $$('[data-sd-card].is-quick').forEach(closeQuick);
  });

  function addVariant(id) {
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () { return fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } }); })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (typeof window.renderCartToDrawer === 'function') window.renderCartToDrawer(cart);
        $$('[data-kr-count]').forEach(function (n) { n.textContent = cart.item_count; });
        if (typeof window.openCartDrawer === 'function') window.openCartDrawer();
        return cart;
      });
  }
  function closeQuick(card) {
    card.classList.remove('is-quick');
    var o = $('.sd-quick__o', card);
    if (o) o.setAttribute('aria-expanded', 'false');
  }
  function quickMsg(card, txt) {
    var q = card && $('.sd-quick', card);
    if (!q) return;
    var m = $('.sd-quick__msg', q);
    if (!m) { m = doc.createElement('p'); m.className = 'sd-quick__msg'; m.setAttribute('role', 'status'); q.appendChild(m); }
    m.textContent = txt || '';
  }

  doc.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    var b = t.closest('[data-sd-add]');
    if (b) {
      e.preventDefault();
      if (b.disabled || b.classList.contains('is-load')) return;
      var card = b.closest('[data-sd-card]');
      quickMsg(card, '');
      b.classList.add('is-load');
      addVariant(b.getAttribute('data-sd-add'))
        .then(function () {
          b.classList.remove('is-load');
          b.classList.add('is-done');
          setTimeout(function () { b.classList.remove('is-done'); if (card) closeQuick(card); }, 900);
        })
        .catch(function (err) {
          b.classList.remove('is-load');
          quickMsg(card, (err && (err.description || err.message)) || T('error', 'Impossible d\'ajouter cette pièce. Réessaie dans un instant.'));
        });
      return;
    }

    var o = t.closest('[data-sd-quick-open]');
    if (o) {
      e.preventDefault();
      var c = o.closest('[data-sd-card]');
      if (!c) return;
      var on = !c.classList.contains('is-quick');
      $$('[data-sd-card].is-quick').forEach(closeQuick);
      if (on) {
        c.classList.add('is-quick');
        var ob = $('.sd-quick__o', c);
        if (ob) ob.setAttribute('aria-expanded', 'true');
      }
      return;
    }

    if (!t.closest('.sd-quick')) $$('[data-sd-card].is-quick').forEach(closeQuick);
  });

  var hideOut = LS.get('sd-hide-out') === '1';
  function applyOut() {
    $$('[data-sd-gridwrap]').forEach(function (w) { w.classList.toggle('sd-hide-out', hideOut); });
    $$('[data-sd-out]').forEach(function (b) {
      var isHide = b.getAttribute('data-sd-out') === 'hide';
      b.setAttribute('aria-pressed', String(isHide === hideOut));
    });
  }
  doc.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-sd-out]');
    if (!b) return;
    hideOut = b.getAttribute('data-sd-out') === 'hide';
    LS.set('sd-hide-out', hideOut ? '1' : '0');
    applyOut();
  });
  applyOut();

  function etaDate() {
    var d = new Date(), n = 0;
    while (n < 4) {
      d.setDate(d.getDate() + 1);
      var w = d.getDay();
      if (w !== 0 && w !== 6) n++;
    }
    var lang = window.SH4DE_LANG || html.getAttribute('lang') || 'fr';
    try { return d.toLocaleDateString(lang, { weekday: 'long', day: 'numeric', month: 'long' }); }
    catch (e) { return d.toLocaleDateString(); }
  }
  var eta = etaDate();
  $$('[data-sd-eta]').forEach(function (el) {
    el.textContent = (el.getAttribute('data-sd-eta') || '') + eta;
    el.hidden = false;
  });
  $$('[data-v2-eta]').forEach(function (el) {
    el.textContent = (el.getAttribute('data-v2-eta') || '') + eta;
    el.hidden = false;
  });

  var rv = $$('[data-sd-rv]');
  if (rv.length && !reduce && 'IntersectionObserver' in window) {
    html.classList.add('sd-rv-on');
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: .08 });
    rv.forEach(function (el) { io.observe(el); });
  }

  var vid = $('.sd-hero__vid');
  if (vid) {
    if (reduce) { try { vid.pause(); } catch (e) {} }
    else if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        if (es[0].isIntersecting) { var p = vid.play(); if (p && p.catch) p.catch(function () {}); }
        else vid.pause();
      }).observe(vid);
    }
  }
})();
